import { Cookie } from 'ng2-cookies/ng2-cookies'

const RECORDING_CONFIG = {
  MAX_ROUTES_ALLOWED: 5,
  MAX_API_CALLS_ALLOWED: 15
}

interface CookieInstance extends Cookie {
  getAll()
}

interface ApiCalls {
  request: string[]
  response: string[]
  retry: string[]
  errors: Array<Response | Error>
}

export class AppMetricsService {

  private _routes: string[] = []
  // TODO [GitHub Issue] (enhancement, nice to have) Improve app metrics structure | We need to find a better way to log data
  // in a way that would allows us to easily follow a sequence. Something like
  // { requestId: { request: ..., response: ..., retry: ..., errors: ... } }
  private _apiCalls: ApiCalls = { request: [], response: [], retry: [], errors: [] }
  private _startDate: Date
  private _cookieStore: CookieInstance

  private get _upTime(): number {
    const currentDate = new Date()
    return Math.round((currentDate.getTime() - this._startDate.getTime()) / 1000)
  }

  public constructor(cookieStore: Cookie) {
    this._cookieStore = cookieStore as CookieInstance
    this._startDate = new Date()
  }

  public logRoute(route: string) {
    const newIndex = this._routes.length % RECORDING_CONFIG.MAX_ROUTES_ALLOWED
    this._routes[newIndex] = route
  }

  public logApiRequest(uri: string, method: string) {
    this._logApiCall(uri, method, 'request')
  }

  public logApiResponse(uri: string, method: string, status: string) {
    this._logApiCall(uri, method, 'response', status)
  }

  public logApiRetry(uri: string, method: string) {
    this._logApiCall(uri, method, 'retry')
  }

  public logApiError(error) {
    this._apiCalls.errors.push(error)
  }

  public toJson() {
    return {
      routes: this._routes,
      apiCalls: this._apiCalls,
      upTime: this._upTime,
      cookies: this._cookieStore.getAll()
    }
  }

  private _logApiCall(uri: string, method: string, type: string, status = '') {
    const date = new Date()
    const statusString = status ? `| ${status}` : ''
    const newIndex = this._apiCalls[type].length % RECORDING_CONFIG.MAX_API_CALLS_ALLOWED
    this._apiCalls[type][newIndex] = `${method} | ${uri} | ${date.toString()} ${statusString}`
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/app-metrics/app-metrics.service.ts